import { sleep } from '../../../../utils/async'
import {
  DOMONDA_PENDING_STATUSES,
  DOMONDA_POLL_FIRST_ATTEMPT,
  DOMONDA_POLL_INTERVAL_MS,
  DOMONDA_POLL_MAX_ATTEMPTS,
  DOMONDA_RESULT_SUCCESS_STATUS,
} from '../../InvoiceModal.constants'

// Polls the Domonda parsing result until it succeeds, fails, or runs out of
// attempts: calls `onSuccess` with the parsed result, or `onError` on failure /
// timeout. Stops silently when polling was cancelled.
export async function checkDomondaResultStatus(
  eventId,
  { getResult, isCancelled, onError, onSuccess }
) {
  for (
    let attempt = DOMONDA_POLL_FIRST_ATTEMPT;
    attempt <= DOMONDA_POLL_MAX_ATTEMPTS && !isCancelled();
    attempt += 1
  ) {
    try {
      const { data } = await getResult(eventId)

      if (data?.status === DOMONDA_RESULT_SUCCESS_STATUS) {
        onSuccess(data?.result ?? null)

        return
      }

      if (!DOMONDA_PENDING_STATUSES.includes(data?.status)) {
        onError()

        return
      }
    } catch {
      onError()

      return
    }

    await sleep(DOMONDA_POLL_INTERVAL_MS)
  }

  if (!isCancelled()) {
    onError()
  }
}
